export enum ProductEventType {
    MANUFACTURED = 'manufactured',
    ADDED_TO_STORAGE = 'added-to-storage',
    SOLD_VIA_WEBSHOP = 'sold-via-webshop',
    TEASED = 'teased',
    SOLD_TO_PARTNER = 'sold-to-partner',
    SOLD_ON_FESTIVAL = 'sold-on-festival',
    MOVED_OUT_TO_FESTIVAL = 'moved-out-to-festival',
    RETURNED_FROM_FESTIVAL = 'returned-from-festival',
    DELEGATED_TO_PARTNER = 'delegated-to-partner',
    RETURNED_FROM_DELEGATION = 'returned-from-delegation',
    SOLD_FROM_DELEGATION = 'sold-from-delegation',
    SCRAPPED = 'scrapped',
    RETURNED_FROM_SCRAP = 'returned-from-scrap',
    GAVE_AWAY_AS_HONORARY_COPY = 'gave-away-as-honorary-copy',
    MOVED_BETWEEN_STORAGES = 'moved-between-storages'
}

export const productEventTypeFilterByKey: Record<string, ProductEventType> = Object.keys(ProductEventType).reduce(
    (acc, key) => {
        acc[key] = ProductEventType[key as keyof typeof ProductEventType];
        return acc;
    },
    {} as Record<string, ProductEventType>
);

export function getProductEventTypeEnumKeys(): (keyof typeof ProductEventType)[] {
    return Object.keys(ProductEventType).filter((key) => isNaN(Number(key))) as (keyof typeof ProductEventType)[];
}

export function getProductEventTypeByKey(key: string): string | null {
    if (key in ProductEventType) {
        return ProductEventType[key as keyof typeof ProductEventType];
    }
    return null;
}

export function getProductEventTypeByValue(value: string): string | null {
    const result = Object.keys(ProductEventType).find((key) => ProductEventType[key as keyof typeof ProductEventType] === value);
    return result ?? null;
}
